// Favorites persistence. Image blobs live in IndexedDB (presigned/server
// URLs expire and localStorage is too small for PNG tiles); a lightweight
// index mirrors to localStorage so the shelf can render instantly.

const DB_NAME = 'sogni-infinity';
const STORE = 'favorites';
const INDEX_KEY = 'sogni-infinity-favs';

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: 'id' });
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function tx(mode, fn) {
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const out = fn(t.objectStore(STORE));
    t.oncomplete = () => resolve(out?.result ?? out);
    t.onerror = () => reject(t.error);
  });
}

export function favIndex() {
  try {
    return JSON.parse(localStorage.getItem(INDEX_KEY) || '[]');
  } catch {
    return [];
  }
}

function writeIndex(list) {
  localStorage.setItem(INDEX_KEY, JSON.stringify(list));
}

// `streamId` is the public-stream entry this image occupies, kept so a later
// upscale can update that entry in place instead of publishing a duplicate.
export async function saveFavorite({
  id,
  blob,
  label,
  emoji,
  seed,
  prompt,
  model,
  size,
  streamId
}) {
  await tx('readwrite', (store) =>
    store.put({ id, blob, label, emoji, seed, prompt, model, size, streamId, ts: Date.now() })
  );
  const list = favIndex().filter((f) => f.id !== id);
  list.unshift({ id, label, emoji, seed });
  writeIndex(list);
}

/** Full stored record: blob plus the prompt/seed metadata behind the tile. */
export async function loadFavorite(id) {
  return tx('readonly', (store) => store.get(id));
}

export async function removeFavorite(id) {
  await tx('readwrite', (store) => store.delete(id));
  writeIndex(favIndex().filter((f) => f.id !== id));
}
